import { useQuery } from '@tanstack/react-query'
import CustomTabPanel from 'components/custom-tab-panel'
import Header from 'components/header'
import { HeaderModule } from 'components/header-module'
import Loading from 'components/loading'
import Page from 'components/page'
import Wrapper from 'components/wrapper'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useAuth } from 'contexts/auth'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { loadItem } from 'services/requests'
import useContract from 'store/contracts'
import extractState from 'utils/organization/extract-state'
import ContractsHeader from './header'
import PageContracts from './page-contracts'
import ContratcsTools from './page-tools'

interface IRouteParams {
  organizationId: string
}

const Contracts = () => {
  const { actualTab, actualOrganization, updateOrganization } = useContract()
  const { user } = useAuth()

  const { organizationId } = useParams<IRouteParams>()

  const { data, isLoading } = useQuery({
    queryKey: ['contracts', 'organization', organizationId],
    queryFn: () => loadItem('/organizations', organizationId),
    enabled: actualOrganization.id == undefined && !!organizationId,
  })

  useEffect(() => {
    if (data && actualOrganization.id == undefined && organizationId) {
      const organizationState = extractState(data?.data.data)
      updateOrganization(organizationState)
    }
  }, [data, organizationId])

  if (isLoading || actualOrganization.id == undefined) {
    return (
      <WrapperWithHeader>
        <Loading />
      </WrapperWithHeader>
    )
  }

  return (
    <Wrapper>
      <Header>
        <HeaderModule.title
          text='Contratos'
          backRoute={user && user.isSeller ? `/customers` : ''}
        />
        <ContractsHeader />
      </Header>

      <Page>
        <CustomTabPanel
          value={actualTab}
          index={0}
          node={<PageContracts />}
        />

        <CustomTabPanel
          value={actualTab}
          index={1}
          node={<ContratcsTools />}
        />
      </Page>
    </Wrapper>
  )
}

export default Contracts
